import { useCallback } from 'react';
import { useLocation, useNavigate, NavigateOptions as RRDNavOptions } from 'react-router-dom';

interface NavigateOptions {
    newPath: string;
    ignoredParams?: string[];
    additionalParams?: Record<string, string>;
    navigateOptions?: RRDNavOptions;
}

export const useNavigateWithCurrentQueryParams = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const navigateWithCurrentQueryParams = useCallback(
        (options: NavigateOptions) => {
            const { newPath, ignoredParams, additionalParams, navigateOptions } = options;
            const queryParams = new URLSearchParams(location.search);

            if (ignoredParams) {
                ignoredParams.forEach((param) => {
                    queryParams.delete(param);
                });
            }

            if (additionalParams) {
                Object.entries(additionalParams).forEach(([key, value]) => {
                    queryParams.set(key, value);
                });
            }

            const queryString = queryParams.toString();
            const newUrl = queryString ? `${newPath}?${queryString}` : newPath;

            navigate(newUrl, navigateOptions);
        },
        [location.search, navigate],
    );

    return navigateWithCurrentQueryParams;
};
